<template>
  <div id="FacultiesAdmin" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="pageTitle">Faculties & Departments</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-header">Faculties/Departments</div>
          <div class="card-body">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Departments</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(faculty, index) in faculties" :key="faculty.id">
                  <td scope="row" style="vertical-align: middle;">{{ index + 1 }}</td>
                  <th style="vertical-align: middle; color:green">{{ faculty.ref }}</th>
                  <th style="vertical-align: middle;">
                    {{ faculty.name }}
                  </th>
                  <td>
                    <!-- -->
                    <table class="table table-sm table-borderless">
                      <tr v-for="(d, i) in faculty.departments" :key="d.id">
                        <th style="color:green">{{ d.ref }}</th>
                        <td>{{ d.name }}</td>
                      </tr>
                    </table>

                    <!--  -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Faculties',

  data() {
    return {
      faculties: []
    }
  },

  mounted() {
    let loading = this.$loading.show()
    axios.get('/admin/faculties').then(res => {
      if (res.data.status == 'success') {
        this.faculties = res.data.faculties
      }
      loading.hide()
    })
  }
}
</script>

<style scoped>
.middle {
  vertical-align: middle;
}
</style>
